import { render } from '@mairistem/module';
import * as Sentry from '@sentry/react';
import * as React from 'react';
import AppIxchange from './AppIxchange';
import ErrorFallback from './components/ErrorFallback/ErrorFallback';
import { initialize } from './sentry';
import '@mairistem/composants/lib/composants.css';
import '@mairistem/comptabilite/comptabilite.css';
import '@mairistem/finances-utils/finances-utils.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

initialize();

const errorBoundaryFallback = ({
	error,
	resetError,
}: {
	error: unknown;
	resetError: () => void;
}) => (
	<ErrorFallback
		error={error instanceof Error ? error : undefined}
		resetError={resetError}
	/>
);

render(
	<Sentry.ErrorBoundary fallback={errorBoundaryFallback}>
		<AppIxchange />
	</Sentry.ErrorBoundary>,
);
